const configs = {
    light: {
        background: {
            color: {
                value: "#D9D9D9"
            },
            position: "50% 50%",
            repeat: "no-repeat",
            size: "cover"
        },
        fullScreen: {
            enable: true,
            zIndex: -1
        },
        particles: {
            color: {
                value: "#D9D9D9"
            }
        }
    },
    dark: {
        background: {
            color: {
                value: "#1b1a1a"
            },
            position: "50% 50%",
            repeat: "no-repeat",
            size: "cover"
        },
        fullScreen: {
            enable: true,
            zIndex: -1
        },
        particles: {
            color: {
                value: "#1b1a1a"
            }
        }
    }
}

module.exports = configs;